export default __webpack_public_path__ + "static/media/paper-time.7c1b822f.png";